// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ho","header":"hp","subHeader":"hq","button":"hr","actionLinks":"hs","actionLink":"ht","actionText":"hu"};